<template>
  <v-container
    class="move-warehouse-list"
    fluid>
    <v-row class="white">
      <v-col
        cols="12"
        sm="12"
        md="5"
        lg="6"
        xl="6">
        <h2>Move Warehouse</h2>
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="7"
        lg="6"
        xl="6"
        class="d-flex align-right">
        <v-text-field
          v-model.trim="search"
          placeholder="ชื่อไฟล์"
          class="mr-3"
          outlined
          dense
          color="secondary"></v-text-field>
        <date-picker-form
          v-model="query.filterDate"
          :clearable="true"
          dense
          placeholder="Created Date"
          name="Created Date"
          label="Created Date"
          outlined
          :rules="{ required: false }" />
        <v-btn
          class="ml-3"
          :loading="loading"
          @click="searchItem">
          <v-icon left>
            mdi-magnify
          </v-icon>
          Search
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="header"
          :items="moveWarehouses"
          :items-per-page="query.limit"
          :loading="loading"
          class="elevation-1 mb-5"
          hide-default-footer>
          <template #item.location="{ item }">
            {{ item.location == 'old' ? 'คลังเก่า' : 'คลังใหม่' }}
          </template>
          <template #item.createdAt="{ item }">
            {{ item.createdAt | dateTimeUserFormat }}
          </template>
          <template #item.actions="{ item }">
            <v-btn
              class="mr-3"
              icon
              @click="downloadFile(item.fileUrl)">
              <v-icon>
                mdi-download
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <div class="text-center mt-4">
          <v-pagination
            v-model="query.page"
            color="secondary"
            :length="totalPages"></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MoveWarehouseProvider from '@/resources/MoveWarehouseProvider'

export default {
  data () {
    return {
      moveWarehouseProvider: new MoveWarehouseProvider(),
      totalPages: 0,
      totalItems: 0,
      loading: false,
      search: '',
      moveWarehouses: [],
      defaultPaginate: {
        sortBy: 'name',
        sortOrder: 'desc',
        warehouse: '',
        page: 1,
        limit: 20,
        search: '',
        status: ''
      },
      query: {
        sortBy: 'name',
        sortOrder: 'desc',
        warehouse: '',
        page: 1,
        limit: 20,
        search: '',
        status: '',
        filterDate: null
      },
      header: [
        {
          text: 'name',
          value: 'filename',
          width: 200
        },
        {
          text: 'Location',
          value: 'location',
          sortable: false,
          width: 400
        },
        {
          text: 'warehouse',
          value: 'warehouse.name',
          sortable: false
        },
        {
          text: 'Created At',
          value: 'createdAt',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          align: 'end'
        }
      ]
    }
  },
  computed: {
  },
  watch: {
    query: {
      handler () {
        this.getMoveWarehouse()
      },
      deep: true
    }
  },
  mounted () {
    this.getMoveWarehouse()
  },
  methods: {
    async getMoveWarehouse (isClear = false) {
      if (isClear) {
        this.query = this.defaultPaginate
      }
      try {
        this.loading = true
        const { data } = await this.moveWarehouseProvider.paginate(this.query)
        if (data) {
          this.moveWarehouses = data.results
          this.totalPages = data.pages
          this.totalItems = data.total
        }
      } catch (error) {
        console.error('fetchPaginate', error)
      }
      this.loading = false
    },
    downloadFile (linkSource) {
      const downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.click()
    },
    searchItem () {
      this.query = { ...this.query, search: this.search, page: 1 }
    }
  }
}
</script>

<style scoped>
</style>
